import { render } from "./Position.vue?vue&type=template&id=6cb81f6b&scoped=true&ts=true"
import script from "./Position.vue?vue&type=script&lang=ts"
export * from "./Position.vue?vue&type=script&lang=ts"

import "./Position.vue?vue&type=style&index=0&id=6cb81f6b&lang=less&scoped=true"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb81f6b"]])

export default __exports__